import PageTabs from '../../ui/PageTabs';
import { t } from '../../utils/i18n';
import { useApiEnvironment } from '../../context/ApiEnvironmentContext';
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DmPersonaGate from '../../layout/DmPersonaGate';
import DmUsers from './DmUsers';
import DmConversations from './DmConversations';
import DmNewConversation from './DmNewConversation';
import DmChat from './DmChat';

export default function DmSection() {
  const { pathname } = useLocation();
  const { apiEnvironment } = useApiEnvironment();
  const views = [["conversations", "dmConversations"], ["new", "dmNew"]];
  const active = pathname.startsWith('/dm/c/') ? 'conversations' : pathname.startsWith('/celeb-room/r/') ? 'feed' : pathname.split('/')[2];
  return (
    <div>
    {active !== 'users' && <div className="px-4 sm:px-6 lg:px-8"><PageTabs label={t('adminUi.qa')} active={active} items={views.filter(([id]) => id !== 'follow' || apiEnvironment === 'test').map(([id,key]) => ({id,to:`/dm/${id}`,label:t(`header.nav.${key}`)}))} /></div>}
    <Routes>
      <Route index element={<Navigate to="users" replace />} />
      <Route path="users" element={<DmUsers />} />
      <Route
        path="conversations"
        element={
          <DmPersonaGate>
            <DmConversations />
          </DmPersonaGate>
        }
      />
      <Route
        path="new"
        element={
          <DmPersonaGate>
            <DmNewConversation />
          </DmPersonaGate>
        }
      />
      <Route
        path="c/:conversationId"
        element={
          <DmPersonaGate>
            <DmChat />
          </DmPersonaGate>
        }
      />
      <Route path="*" element={<Navigate to="users" replace />} />
    </Routes>
    </div>
  );
}
